module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Job Rate")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.job.rate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Load Rate")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "disabled": _vm.jobIsNotEditable
    },
    domProps: {
      "value": (_vm.rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Commission")]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-text-success",
    class: {
      'input-group-text-danger': _vm.loadCommissionAmount < 0
    }
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("$" + _vm._s(_vm.loadCommissionAmountAsMoney))]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.loadCommissionPercentage > 0 ? '+' : '') + _vm._s(_vm.loadCommissionPercentage) + "%")])])])])]), _vm._v(" "), _c('h3', [_vm._v("\n      Additional Charges\n\n      "), (_vm.jobIsEditable) ? _c('button', {
    staticClass: "btn btn-info btn-xs pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".additional-charge-collapse",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Charge\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-detail list-detail-additional-charges"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoCharges),
      expression: "haveNoCharges"
    }]
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.loadDecorated.charges), function(charge) {
    return _c('li', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-4 col-lg-7"
    }, [_c('p', [_vm._v(_vm._s(charge.description))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-sm-2 col-lg-1"
    }, [_c('p', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(charge.client_rate))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-sm-2 col-lg-1"
    }, [_c('p', {
      staticClass: "text-right"
    }, [_c('span', {
      staticClass: "text-info"
    }, [_vm._v("(" + _vm._s(charge.carrier_rate) + ")")])])]), _vm._v(" "), _c('div', {
      class: {
        'col-xs-3 col-sm-2 col-lg-2': _vm.jobIsEditable, 'col-xs-6 col-sm-4 col-lg-3': _vm.jobIsNotEditable
      }
    }, [_c('p', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(charge.type))])]), _vm._v(" "), (_vm.jobIsEditable) ? _c('div', {
      staticClass: "col-xs-3 col-sm-2 col-lg-1"
    }, [_c('ladda-button', {
      staticClass: "pull-right btn btn-circle btn-danger",
      attrs: {
        "on-click": _vm.handleDeleteCharge,
        "arguments": [charge]
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1) : _vm._e()])])
  })], 2)]), _vm._v(" "), (_vm.jobIsEditable) ? _c('div', {
    staticClass: "additional-charge-collapse collapse"
  }, [_c('div', {
    staticClass: "ibox-footer"
  }, [_c('h4', [_vm._v("Add Additional Charge")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.description),
      expression: "charge.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.charge.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.charge.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Client Amount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.client_rate),
      expression: "charge.client_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.charge.client_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.charge.client_rate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Carrier Amount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge.carrier_rate),
      expression: "charge.carrier_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.charge.carrier_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.charge.carrier_rate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Charge Type")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "type",
      "options": _vm.chargeTypeOptions
    },
    model: {
      value: (_vm.charge.type),
      callback: function($$v) {
        _vm.charge.type = $$v
      },
      expression: "charge.type"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    staticClass: "m-t-md m-b-md",
    attrs: {
      "on-click": _vm.handleAddCharge,
      "type": "success",
      "size": "small"
    }
  }, [_vm._v("Add Charge")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-sm pull-left",
    attrs: {
      "to": {
        name: 'jobs.show',
        params: {
          id: _vm.load.job.id
        }
      }
    }
  }, [_vm._v("View Job")]), _vm._v(" "), (_vm.jobIsEditable) ? _c('ladda-button', {
    staticClass: "pull-right",
    attrs: {
      "on-click": _vm.handleSaveRate,
      "type": "success",
      "size": "small"
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Admin Controls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No additional charges.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6d493bde"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/AdminControls.vue
// module id = 1032
// module chunks = 0